module.exports = __webpack_public_path__ + "img/company.52f0cd45.svg";